import * as _ from 'lodash';
import { type FunctionComponent } from 'react';

import { NOT_FOUND } from '../../../shared/errors/errorMessage';
import NotFound from '../NotFound';

import Header from './Header';
import { useCurrentPortalId } from './hooks';

const OrganizationPortal: FunctionComponent = ({ children }) => {
  const { errors, value, isLoading } = useCurrentPortalId();

  if (!_.isEmpty(errors) && errors?.includes(NOT_FOUND)) {
    return (
      <NotFound />
    );
  }

  if (value && !isLoading) {
    return (
      <>
        <Header />
        { children }
      </>
    );
  }

  return (<></>);
};

export default OrganizationPortal;
